import Swiper from "swiper";

document.addEventListener("DOMContentLoaded", function () {
  let sliderContainer = document.querySelector(
    ".section-3 .tour-slideshow .view-main-locations-tour-categories"
  );

  if (sliderContainer) {
    sliderContainer.classList.add("swiper-container");
    sliderContainer.style.overflow = "visible";

    let sliderWrapper = sliderContainer.children[0];
    sliderWrapper.classList.remove("view-content");
    sliderWrapper.classList.add("swiper-wrapper");

    let sliderSlides = sliderWrapper.children;

    Array.from(sliderSlides).forEach((slide) => {
      slide.classList.remove("views-row");
      slide.classList.add("swiper-slide");
      slide.style.width = "auto";

      let slideChild = slide.children[0];
      slideChild.style.display = "inline-block";
    });

    let leftArrow = document.querySelector(
      ".section-3 .tour-slideshow .left-arrow"
    );
    let rightArrow = document.querySelector(
      ".section-3 .tour-slideshow .right-arrow"
    );

    let mySwiper = new Swiper(sliderContainer, {
      slidesPerView: "auto",
      spaceBetween: 30,
      grabCursor: true,
      navigation: {
        prevEl: leftArrow,
        nextEl: rightArrow,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });
  }
});
